import { ENTITLEMENTS } from "constants/entitlements"
import { LazyAuthPaywallModal } from "modules/paywall/LazyAuthPaywallModal"
import { LazyProPaywallModal } from "modules/paywall/LazyProPaywallModal"

type CreateChartPaywallProps =
  | {
      limitReached: true
      isOpen: boolean
      setIsOpen: (isOpen: boolean) => void
    }
  | {
      limitReached?: false
      isOpen: boolean
      setIsOpen: (isOpen: boolean) => void
    }

export function CreateChartPaywall({
  isOpen,
  setIsOpen,
  limitReached,
}: CreateChartPaywallProps) {
  if (limitReached) {
    return (
      <LazyProPaywallModal
        type="save_new_chart"
        featureText={`You can only save up to ${ENTITLEMENTS.FREE.CHARTS} charts as a free user.`}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onClose={() => setIsOpen(false)}
      />
    )
  }

  return (
    <LazyAuthPaywallModal
      featureText="Explore onchain fundamentals with Token Terminal’s chart builder."
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  )
}
